<app-common-modal-form
  header="Send Agreement To"
  icon="''"
  confirmText="Send"
  closeText="Cancel"
  [isLoading]="isLoading()"
  [formGroup]="form"
  (close)="close()"
  (confirm)="submit()"
>
  <div class="modal-content-element d-flex flex-column gap-24 pt-3">
    <app-checkbox
      label="I have Bank Details ready"
      formControlName="haveBankAccount"
    />

    @if (form.controls.haveBankAccount.value) {
      <div class="d-flex flex-column gap-24">
        <div class="bank-data-grid">
          <div>
            <app-bsb-masked-input formControlName="bsb"/>
          </div>

          <div class="flex-grow-1">
            <app-input-number
              label="Bank Account Number"
              formControlName="bankAccountDetails"
              [min]="99999"
              [max]="9999999"
            />
          </div>
        </div>

        <app-input
          label="Account Name"
          formControlName="accountName"
        />
      </div>
    }
  </div>

  <app-divider margin="32px 0"/>

  <div class="modal-content-element pb-4">
    <app-contacts-select
      label="Send To"
      formControlName="contactId"
      [entityId]="entityId"
      [contacts]="contacts"
    />
  </div>
</app-common-modal-form>
